<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    scrollable
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ bookingTitle }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right"></v-col>
        </v-row>
      </v-toolbar>

      <v-card-text v-show="!refreshing && bookings.length == 0">
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-list-item>
              <v-text-field readonly :value="$store.getters.memberFullName" :label="$t('name')"></v-text-field>
            </v-list-item>

            <v-list-item>
              <v-text-field readonly :value="$store.getters.memberPhoneId" :label="$t('phone_no')"></v-text-field>
            </v-list-item>

            <v-select v-model="partySize" :items="partySizeRange" :label="$t('number_of_party')"></v-select>

            <v-row v-if="reserve">
              <v-col>
                <v-menu
                  close-on-content-click
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="bookingDate"
                      :label="$t('date')"
                      persistent-hint
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="bookingDate" :allowed-dates="allowedDates" no-title></v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-select
                  :items="bookingTimes"
                  v-model="bookingTime"
                  hide-details="true"
                  :label="$t('time')"
                  :no-data-text="$t('booking.check-other-times')"
                ></v-select>              
              </v-col>
            </v-row>          

            <v-textarea :label="$t('booking.remark')" maxlength="100" v-model="remark"></v-textarea>

            <v-btn class="horizontal-center login-button mt-4" :disabled="!valid" @click="confirm" color="primary">{{
              $t("confirm")
            }}</v-btn>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-text v-show="!refreshing && bookings.length > 0">
        <v-list>
          <v-list-item class="booking-item" v-for="(booking, index) in bookings" :key="index">
            <v-list-item-content>
              <v-row class="booking-no"
                ><v-col class="t-title" cols="4">{{ bookingNoTitle }}</v-col
                ><v-col class="t-value">{{ booking.BookingNo }}</v-col></v-row
              >
              <v-row
                ><v-col class="t-title" cols="4">{{ bookingTimeTitle }}</v-col
                ><v-col class="t-value">{{ toLocaleString(booking.BookingTime) }}</v-col></v-row
              >
              <v-row
                ><v-col class="t-title" cols="4">{{ $t("booking.party_name") }}</v-col
                ><v-col class="t-value">{{ booking.PartyName }}</v-col></v-row
              >
              <v-row
                ><v-col class="t-title" cols="4">{{ $t("booking.party_size") }}</v-col
                ><v-col class="t-value">{{ booking.PartySize }}</v-col></v-row
              >
              <v-row
                ><v-col class="t-title" cols="4">{{ $t("booking.contact_phone") }}</v-col
                ><v-col class="t-value">{{ booking.ContactPhone }}</v-col></v-row
              >
              <v-row v-if="booking.Remark != ''"
                ><v-col class="t-title" cols="4">{{ $t("booking.remark") }}</v-col
                ><v-col class="t-value">{{ booking.Remark }}</v-col></v-row
              >
              <v-row>
                <v-btn class="horizontal-center cancel-button mt-4" @click="cancel(booking)" color="warning">{{
                  $t("cancel")
                }}</v-btn>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  components: {},

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    reserve: false,
    refreshing: false,
    valid: false,
    partySize: 1,
    partySizeRange: [],
    remark: "",

    bookingDate: null,
    bookingTimes: [],
    bookingTime: null,
    reserveSlotId: 0,  

    status: 1,

    bookings: [],
  }),

  created() {
    //
  },

  computed: {
    bookingTitle() {
      if (this.reserve) return this.$t("booking.reserve");
      else return this.$t("booking.waitlist");
    },

    bookingNoTitle() {
      if (this.reserve) return this.$t("booking.reserve_no");
      else return this.$t("booking.waitlist_no");
    },

    bookingTimeTitle() {
      if (this.reserve) return this.$t("booking.reserve_time");
      else return this.$t("booking.waitlist_time");
    },
  },

  watch: {
    bookingDate() {
      console.log("bookingDate Changed");
      this.updateReserveTimeSlots();
    },

    partySize() {
      console.log("partySize Changed");
      this.updateReserveTimeSlots();
    },
  },

  methods: {
    open(reserve) {
      this.reserve = reserve;

      //this.refreshing = true;
      this.bookingDate = this.toSQLDateString(new Date());
      this.partySize = null;
      this.partySizeRange = [];
      this.remark = "";
      this.bookings = [];

      this.rest_getReserveSlot().then(res => {
        if (res.result == "ok") {
          for (let i = res.MinPartySize; i <= res.MaxPartySize; i++) {
            this.partySizeRange.push(i);
          }
          if (this.partySizeRange.length > 0) this.partySize = this.partySizeRange[0];
        }
      });

      this.rest_getBooking(reserve).then(res => {
        if (res.result == "ok") {
          this.bookings = res.record;
        }
      });

      //this.refreshing = false;
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      this.resolve(false);
      this.dialog = false;
    },

    allowedDates(val) {
      let today = new Date();
      return val >= this.toSQLDateString(today);
    },

    getBookingStatus(booking) {
      let status = 1;
      if (booking.Cancelled) status = 0;
      else if (booking.Served) status = 3;
      else if (booking.Confirmed) status = 2;

      return status;
    },

    async updateReserveTimeSlots() {
      console.log("updateReserveTimeSlots", this.bookingDate, this.partySize);

      let n_reserveSlotId = 0;
      let n_bookingTimes = [];
      let n_bookingTime = null;

      if (this.reserve && this.bookingDate != null && this.partySize != null) {
        let resp = await this.rest_getAvailReserve(this.bookingDate, this.partySize);
        if (resp.result == "ok") {
          if (resp.data != null && resp.data.length > 0) {
            let respData = resp.data;
            n_reserveSlotId = respData[0].ResSlotId;
            n_bookingTimes = respData[0].TimeSlot;
            if (n_bookingTimes.length > 0) {
              n_bookingTime = n_bookingTimes[0];
            }
          }
        }
      }

      this.reserveSlotId = n_reserveSlotId;
      this.bookingTimes = n_bookingTimes;
      this.bookingTime = n_bookingTime;
    },

    confirm() {
      let bookingDateTime = null;
      if (this.reserve) {
        bookingDateTime = this.toDate(this.bookingDate + " " + this.bookingTime + ":00");
        if (!this.isValidDate(bookingDateTime)) {
          this.$root.messageDialog(this.$t("error_alert_title"), "", "BookingTime is not a valid reserve slot");
          return;
        }
      } else {
        bookingDateTime = new Date();
      }

      let confirmMessage = `<b>${this.$t("booking.party_name")}</b><br>${this.$store.getters.memberFullName}<br><br>`;
      confirmMessage += `<b>${this.$t("booking.party_size")}</b><br>${this.partySize}<br><br>`;
      if (this.reserve) {
        confirmMessage += `<b>${this.$t("booking.reserve_time")}</b><br>${this.toLocaleString(
          bookingDateTime
        )}<br><br>`;
      }
      if (this.remark != "") confirmMessage += `<b>${this.$t("booking.remark")}</b><br>${this.remark}<br><br>`;

      this.$root.confirmDialog(this.$t("confirm"), "", confirmMessage).then(confirmed => {
        if (confirmed) {
          this.rest_addBooking({
            partySize: this.partySize,
            contactPhone: this.$store.getters.memberPhoneId,
            reserveSlotId: this.reserve ? this.reserveSlotId : null,
            bookingTime: this.toSQLDateTimeString(bookingDateTime),
            remark: this.remark,
          }).then(resp => {
            if (resp.result == "ok") {
              this.close();
            } else {
              this.$root.messageDialog(this.$t("error_alert_title"), "", resp.result);
            }
          });
        }
      });
    },

    cancel(booking) {
      let question;
      if (this.reserve) question = this.$t("booking.confirm_cancel_reservation");
      else question = this.$t("booking.confirm_cancel_waitlist");
      this.$root.confirmDialog(this.$t("confirm"), "", question).then(confirmed => {
        if (confirmed) {
          this.rest_cancelBooking(booking.BookingNo).then(resp => {
            if (resp.result == "ok") {
              this.bookings = this.bookings.filter(a => a !== booking);
              if (this.reserve && this.bookings.length == 0) {
                this.updateReserveTimeSlots();
              }
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 0px;
  color: black;
}

.v-list-item {
  padding: 0px;
}

.t-title {
  font-weight: bold;
}
.t-value {
  //padding: 4px 0px;
}

.booking-no {
  //font-size: 1.4em;
  //margin-bottom: 8px;
}

.booking-item {
  border-bottom: solid 1px lightgray !important;
}

.booking-status {
  .booking-status-step {
    box-shadow: none !important;

    .v-stepper__step {
      padding-left: 0px;
    }
  }

  .booking-status-step .v-stepper__step:first-child {
    padding-top: 0px !important;
  }
}
</style>
